import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PSF_SHARE_BUTTON_CONFIG = createFcmDetails('psf_share_button_config', {
	owner: 'Monetization Squad',
	context: 'PSF share page',
	description: 'Custom share buttons on PSF share page',
	import: false,
	template: [
		'copy',
		'facebook',
		'instagram',
		'whatsapp',
		'twitter',
		'email',
		'facebookMessenger',
		'sms',
		'line',
		'nextdoor',
		'vk',
		'mobileNativeShare',
		'reddit',
	],
});
